module.exports = __webpack_public_path__ + "img/promo-1.efc3e87d.png";